import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-sr-seller",
  "use": "icon-fi-sr-seller-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-sr-seller\">\r\n  <path d=\"m19.667,15.667v.333c0,1.105-.831,2-1.857,2h-.619c-1.026,0-1.857-.895-1.857-2v-.333s0,.333,0,.333h0c0,1.105-.831,2-1.857,2h-.619c-1.026,0-1.857-.895-1.857-2l1.238-3h10.524l1.238,3c0,1.105-.831,2-1.857,2h-.619c-1.026,0-1.857-.895-1.857-2h0m-4.667-10c0-3.309-2.691-6-6-6S3,2.691,3,6s2.691,6,6,6,6-2.691,6-6Zm7.143,14h-.619c-.673,0-1.306-.18-1.856-.495-.552.315-1.185.495-1.857.495h-.619c-.673,0-1.306-.18-1.857-.495-.551.315-1.184.495-1.856.495h-.619c-.296,0-.581-.042-.857-.108v4.108h11v-4.108c-.277.066-.562.108-.857.108Zm-13.143-4v-.396l.662-1.604h-4.662c-2.761,0-5,2.239-5,5v5h10v-5.338c-.615-.709-1-1.636-1-2.662Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-sr-seller.svg
// module id = +b5e
// module chunks = 36